import { put, call } from 'redux-saga/effects';

import { getUser } from '@api/user';
import { userModel } from '@models/User';
import { fetchUserOrganizationsSaga } from '@sagas/user/fetchUserOrganizationsSaga';
import { handleGetUserAccountSaga } from '@sagas/user/handleGetUserAccountSaga';
import { userGetSuccessAction, userGetFailureAction } from '@store/user/user.actions';

export const getUserDetailsSaga = function* ({ payload: { userId } }) {
  const response = yield call(getUser, userId);
  let userOrganization;
  if (response.organization) {
    userOrganization = yield fetchUserOrganizationsSaga(response.organization);
  }

  if (userOrganization && userOrganization.orgs.message) {
    yield put(userGetFailureAction(userOrganization.orgs));
  } else {
    const userResponse = { ...response };

    yield put(userGetSuccessAction(userModel(userResponse)));

    if (response?.account) {
      yield handleGetUserAccountSaga({ payload: response?.account });
    }
  }
};
